import { apiHelper } from '@/utils'
import { API } from '@/constants'
import { buildListingParams } from './listing.params'

export const roleService = {
  getAllRoles,
  getRole,
  getPermissions,
  createRole,
  updateRole,
  updateRoleStatus,
}

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  return buildListingParams(filter, {
    is_active: filter?.isActive,
    // "Which roles grant this right" — the question you ask before taking a
    // permission away from somebody.
    permission_codes: filter?.permissionCodes,
  })
}

export async function getAllRoles(filter) {
  return apiHelper(API_URL).get('/roles', { params: buildParams(filter) })
}

export async function getRole(uuid) {
  return apiHelper(API_URL).get(`/roles/${uuid}`)
}

/**
 * Every right the system has, grouped by module.
 *
 * `/roles/permissions` and not `/permissions`: it needs Read Role, because the
 * only thing it is for is rendering a role. The grouping is derived from the
 * permission code server-side, so a right added to the seeder appears here with
 * nothing else to update.
 */
export async function getPermissions() {
  return apiHelper(API_URL).get('/roles/permissions')
}

export async function createRole(data) {
  return apiHelper(API_URL).post('/roles', {
    name: data.name,
    // Always sent, even empty: the server's rule is `present`, and leaving the
    // key out would be indistinguishable from the form forgetting to send it —
    // at which point an edit would silently strip every right.
    permission_codes: data.permissionCodes || [],
  })
}

export async function updateRole(uuid, data) {
  return apiHelper(API_URL).put(`/roles/${uuid}`, {
    name: data.name,
    permission_codes: data.permissionCodes || [],
  })
}

export async function updateRoleStatus(uuid, isActive) {
  return apiHelper(API_URL).patch(`/roles/${uuid}/status`, { is_active: isActive })
}
